<template>
  <b-card class="shadow mb-2 p-0" no-body>

    <div class="d-flex justify-content-between p-3">
      <h3 class="m-0">{{ $t('dexpara.filtros.integracoes') }}</h3>
      <b-button variant="link d-lg-none" v-b-toggle.integration-content>
        <i class="fas fa-chevron-circle-down"></i>
      </b-button>
    </div>

    <b-collapse id="integration-content" class="pl-3 pr-3 pb-3 " visible>
      <b-form-group :label="$t('dexpara.filtros.origem')" label-for="input-integration-origin">
        <SelectComponent
            id="input-integration-origin"
            :model="integration.origin"
            :options="integrations | idNameToValueLabel"
            :searching="isLoading"
            @input="evt => {integration.origin = evt; changed()}"
        />
      </b-form-group>
      <b-form-group :label="$t('dexpara.filtros.destino')" label-for="input-integration-destination">
        <SelectComponent
            id="input-integration-destination"
            :model="integration.destination"
            :options="integrations | idNameToValueLabel"
            :searching="isLoading"
            @input="evt => {integration.destination = evt; changed()}"
        />
      </b-form-group>
      <slot name="options"/>
      <b-button id="btn-save" type="submit" variant="success" class="w-100" @click="$emit('save')">
        <i class="fas fa-save"/> Salvar
      </b-button>
    </b-collapse>

    <b-list-group flush>
      <b-list-group-item>
        <div class="d-flex justify-content-between p-3">
          <h3 class="m-0">{{$t('dexpara.copia.copiar_dexpara')}}</h3>
          <b-button variant="link d-lg-none" v-b-toggle.integration-content>
            <i class="fas fa-chevron-circle-down"></i>
          </b-button>
        </div>

        <b-collapse id="copy-integration-content" class="pl-3 pr-3 pb-3 " visible>
          <b-form-group :label="$t('dexpara.copia.tipo_integracao')" label-for="input-copy-integration-type">
            <SelectComponent
                id="input-copy-integration-type"
                :model="copy.integration_type"
                :options="integrationsType"
                :searching="isLoading"
                @input="evt => {copy.integration_type = evt;}"
            />
          </b-form-group>
          <b-form-group :label="$t('dexpara.copia.para_integracao')" label-for="input-copy-integration-to">
            <SelectComponent
                id="input-copy-integration-to"
                :model="copy.integration_to"
                :options="integrations | idNameToValueLabel"
                :searching="isLoading"
                @input="evt => {copy.integration_to = evt;}"
            />
          </b-form-group>
          <b-button id="btn-save" type="submit" variant="success" class="w-100" @click="$emit('save-copy', copy)">
            <i class="fas fa-save"/> Salvar
          </b-button>
        </b-collapse>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>
import SelectComponent from "@/components/SelectComponent";
import {mapGetters} from "vuex";
export default {
  name: "DeXParaIntegrations",
  components: {SelectComponent},
  computed: {
    ...mapGetters({
      integrations: 'integration/all',
      isLoading: 'integration/isLoading',
    }),
    integrationsType() {
      return [
        {
          value: 'origin',
          label: this.$t('dexpara.copia.origem')
        },
        {
          value: 'destiny',
          label: this.$t('dexpara.copia.destino')
        }
      ]
    }
  },
  data() {
    return {
      integration: {
        origin: null,
        destination: null
      },
      copy: {
        integration_type: null,
        integration_to: null
      }
    }
  },
  methods: {
    changed() {
      this.$emit('change', this.integration)
    }
  }
}
</script>